import axios from 'axios';
import * as actionTypes from './actionTypes';

export const getMap = (res) => {
	return {
		type: actionTypes.APIResponse,
		mapData: res
	}
}

export const getStats = (country) => {
	return {
		type: actionTypes.APIStats,
		country: country
	}
}

export const APIFail = (error) => {
	return {
		type: actionTypes.APIError,
		error: error
	}
}

export const getMapAsync = () => {
	return dispatch => {
	   axios('https://disease.sh/v3/covid-19/countries')
	   	.then ( response => {
	   	//	console.log('fetch', response);
	   		dispatch(getMap(response));
	   	}).catch( e => dispatch(APIFail(e)))

	}
}

export const getStatsAsyc = (country) => {
    return dispatch => {
    	axios(`https://disease.sh/v3/covid-19/countries/${country}?strict=true`)
    	.then (response => {
    	//	console.log('fetch', response);
    		dispatch(getStats(response));
    	}).catch( e => dispatch(APIFail(e)))
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/actions.js